// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".responsive-width{width:100%}@media (min-width:768px){.responsive-width{width:75%}}@media (min-width:992px){.responsive-width{width:75%}}@media (max-width:767px){.clinic-booking{margin-top:2rem!important}}.doc-speciality.yes{text-decoration:none;transition:color .3s ease-in-out}.doc-speciality.yes:hover{color:#20c0f3}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
